<template>
  <div>
    <div class="flight-diaglo" v-if="dialogVisible">
      <div class="flight-diaglo-bg" @click="handleClose"></div>
      <!-- 加载弹框 -->
      <div class="flight-diaglo-loading" v-show="getLoading">
        <!-- 加载中 -->
        <div v-if="!showErrormsg" class="loadingmsg">
          <img src="http://img.tuniucdn.com/img/1/common/loading-72x72.gif" /><span>请稍后...</span>
        </div>
        <!-- 加载失败 -->
        <div v-else class="errormsg">
          加载失败，请<a @click="reload" href="javascript:void(0);" class="click">
            点击 </a>重试！
        </div>
      </div>
      <!-- 选择机票弹框 -->
      <div class="flight-diaglo-content" v-show="!getLoading">
        <!-- 头部选择（推荐组合或自由组合） -->
        <header class="fc-header">
          <h2 :class="{ active: getTabName === 'first' }" @click="handleClick('first')" v-if="showSuggest">
            推荐组合
          </h2>
          <h2 :class="{ active: getTabName === 'second' }" @click="handleClick('second')" v-show="getCanReplaceTicket">
            自由组合
          </h2>
          <!-- 关闭弹框 -->
          <span @click="handleClose" class="close_wrap">
            <img src="~@/assets/img/close.png" alt="" />
          </span>
        </header>
        <div class="fc-content">
          <!-- 已经选中的行程的列表-->
          <div class="fc-content-trip">
            <selected />
          </div>
          <!-- 主要内容 -->
          <div class="fc-content-main clearfix">
            <!-- 左侧筛选（自由组合有，推荐组合没有） -->
            <div class="fc-main-left" v-if="getTabName === 'second'">
              <asideselect />
            </div>

            <!-- 右侧 -->
            <div class="fc-main-right" :class="{ width100: getTabName === 'first' }">
              <!-- 已经选中的行程的列表-->
              <selectedm :closeDialog="closeDialog" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import asideselect from "./aside.vue";
import selectedm from "./main.vue";
import selected from "./selected.vue";
//整理格式化请求参数
import requestParameter from "../../utils/requestParameter";
//处理各种数据
import flightTickets from "../../utils/flightTickets";
import rxjs from "../../utils/rxjs";
// import { constants } from "os";
// import func from "vue-editor-bridge";

export default {
  name: "flightmodal",
  components: {
    asideselect,
    selected,
    selectedm,
  },
  data () {
    return {
      closeDialog: false,
    };
  },
  computed: {
    getCanReplaceTicket () {
      let obj = new flightTickets();
      return obj.getCanReplaceTicket(this.$store);
    },
    //获取当前是推荐组合还是自由组合
    getTabName () {
      return this.$store.getters.getTabName;
    },
    //获取当前加载数据状态（加载完成还是加载中）
    getLoading () {
      // debugger;
      let loading = this.$store.getters.getLoading;
      return loading;
    },
    //获取当前接口是否请求状态（正常返回数据还是请求报错 ）
    showErrormsg () {
      let isShow = this.$store.getters.showErrormsg;
      // debugger;
      return isShow;
    },
    //获取当前模态框状态（关闭还是开启）
    dialogVisible: {
      get: function () {
        return this.$store.getters.getDialogVisible;
      },
      set: function () { },
    },
    // 获取当前是否有推荐组合这个tab选项
    showSuggest () {
      try {
        let pkgTicketList =
          this.$store.getters.getRxjsMsg.parameter.groupTickets.pkgTicketList;
        if (!pkgTicketList) {
          // this.$store.commit("setTabName", "second");
          // this.$options.methods?.loadData.bind(this)();
          return false;
        }
      } catch (e) { }

      return true;
    },
  },
  methods: {
    //关闭模态框
    //如果是已经加载了flight组件，
    //就通知flight组件关闭自身定时后再去关闭模态框
    handleClose: function () {
      if (!this.getLoading) {
        this.$store.commit("setDialogVisible", false);
      } else {
        this.closeDialog = true;
      }
    },
    //切换tab状态(推荐组合或自由组合)
    handleClick: function (tabName) {
      if (tabName == "first") {
        this.$store.commit("setTicketIndex", -1);
      }
      this.$options.methods.showTab.bind(this)(tabName);
    },
    //切换tab状态(推荐组合或自由组合)
    showTab: function (tabName) {
      let obj = new flightTickets();
      //数据状态初始化
      obj.clean(this.$store);
      obj.cleanSecondTicketList(this.$store);
      this.$store.commit("setTabName", tabName);
      //？？？？？下面这两个不是已经在obj.clean函数里写过了吗
      // this.$store.commit("setChoseTicket", []);
      // this.$store.commit("setCurrentIndex", 1);
      //去加载并处理数据
      this.$options.methods.loadData.bind(this)();
    },
    //请求出错时重新加载数据
    reload () {
      this.$options.methods.loadData.bind(this)();
      this.$store.commit("setErrormsg", false);
    },
    //加载数据并处理数据
    loadData () {
      // debugger;
      //获取当前tab（是推荐组合还是自由组合）
      let tabName = this.$store.getters.getTabName;
      //获取一开始传进来的值
      let rxjs_msg = this.$store.getters.getRxjsMsg;
      let TicketsList = {};
      //规范格式化参数
      let requestObj = new requestParameter(this.$store);
      if (tabName == "first") {
        //推荐组合 关闭loading
        this.$store.commit("setLoading", false);
      } else {
        //自由组合：获取数据，数据格式如下
        // freeFlight: { success: true, data: { flightInlandItemSearchList: [] } },
        this.$store.commit("setLoading", true);
        let freeFlight = this.$store.getters.getFreeFlight;
        let flightInlandItemSearchList = null;
        try {
          let flightInlandItemSearchList =
            freeFlight.data.flightInlandItemSearchList;
        } catch (e) { }

        if (flightInlandItemSearchList) {
          if (flightInlandItemSearchList.length > 0) {
            this.$store.commit("setShowProgress", false);
          } else {
            let parameter = requestObj.secondParameter(1, 1, 0);
            this.$store.commit("setParameter3", parameter);
            //请求机票散客票3.0列表接口数据
            this.$store.dispatch("freeFlightList", parameter);
          }
        } else {
          let parameter = requestObj.secondParameter(1, 1, 0);
          this.$store.commit("setParameter3", parameter);
          //请求机票散客票3.0列表接口数据
          this.$store.dispatch("freeFlightList", parameter);
        }
      }
    },
    //去加载数据
    getTickets: function () {
      this.$options.methods.loadData.bind(this)();
    },
  },
  mounted: function () {
    // debugger;
    let rxjsObj = new rxjs();

    const rxjs_subject = rxjsObj.getSubject();
    let obj = new flightTickets();
    obj.clean(this.$store);

    // let rxjs_msg = {
    //   "message": "flightmodal",
    //   "parameter": {
    //     "baseInfo": {
    //       "defaultTicketPrice": 100,
    //       "journeyNum": 1,
    //       "isInternational": 0,
    //       "noCacheFlag": true,
    //       "productId": 210598350,
    //       "isFranchise": 0,
    //       "bookCityCode": 1602,
    //       "departCityCode": 1602,
    //       "backCityCode": 1602,
    //       "adult": 2,
    //       "child": 0,
    //       "departDate": "2021-09-15",
    //       "freeChild": 0,
    //       "journeyId": 9966136
    //     },
    //     "groupTickets": {
    //       "singleTicketList": {
    //         "international": 0,
    //         "flightTicketLists": [
    //           {
    //             "resId": 0,
    //             "resType": 21,
    //             "resSubType": 0,
    //             "journeyRph": 1,
    //             "seqNum": 1,
    //             "flightKey": "CZ6668",
    //             "transferFlag": 0,
    //             "departTime": "2021-09-15",
    //             "durationTime": "185",
    //             "priceInfoId": "MTMjOA==",
    //             "specVendorId": "",
    //             "inlandTransferInfoList": null,
    //             "priceFlightCabinList": [
    //               {
    //                 "seatTypeCode": 1,
    //                 "seatTypeName": "经济舱",
    //                 "seatAliasName": "",
    //                 "cabinCode": "E",
    //                 "cabinCodeChild": "E",
    //                 "baggageInfo": "南京-三亚：免费托运行李20公斤，免费手提行李1件5公斤，备注：尺寸限制：长宽高之和小于等于115厘米;",
    //                 "mealCode": "0F",
    //                 "mealName": "无餐",
    //                 "seatDiscount": null,
    //                 "baggageInfoEntity": null,
    //                 "baggageInfoEntityCHD": null,
    //                 "baggageInfoEntityBaby": null,
    //                 "priceDetailInfo": "最少成行人数为：1，最多成行人数为：5",
    //                 "adultPrice": 1021,
    //                 "childPrice": 0,
    //                 "babyPrice": null,
    //                 "price": 2042,
    //                 "adultFraPrice": 0,
    //                 "childFraPrice": 0,
    //                 "babyFraPrice": null,
    //                 "fraPrice": 0,
    //                 "seatStatus": "9"
    //               }
    //             ],
    //             "inlandFlightItemInfoLists": [
    //               {
    //                 "departureDate": "2021-09-15",
    //                 "airlineCompany": "中国南方航空",
    //                 "flightNo": "CZ6668",
    //                 "airplaneType": "32M",
    //                 "airplaneTypeName": "空客A321",
    //                 "departureTime": "21:30",
    //                 "arrivalTime": "00:35",
    //                 "dportName": "禄口机场",
    //                 "aportName": "凤凰机场",
    //                 "duration": "185",
    //                 "stopNum": 0,
    //                 "stopInformation": "",
    //                 "stopPoints": null,
    //                 "codeShare": "",
    //                 "shareAirlineName": null,
    //                 "arrivalDate": "2021-09-16",
    //                 "terminalArrival": "T1",
    //                 "terminalDeparture": "T1",
    //                 "departureCityName": "南京",
    //                 "destinationCityName": "三亚",
    //                 "dportIataCode": "NKG",
    //                 "aportIataCode": "SYX",
    //                 "orgCityIataCode": "NKG",
    //                 "dstCityIataCode": "SYX",
    //                 "airlineIataCode": "CZ",
    //                 "avgDelayTime": "63",
    //                 "planeModel": 2,
    //                 "airComImageUrl": "https://m.tuniucdn.com/fb2/t1/G1/M00/2F/57/Cii9EFbnv8qIS0CeAAAUupbe7w4AACn3AP_6FMAABTS246.png",
    //                 "sairComImageUrl": null,
    //                 "transferFlag": 1,
    //                 "journeyNumber": 0,
    //                 "visaTips": null,
    //                 "onTimeRate": null,
    //                 "saleControl": null,
    //                 "additionals": null,
    //                 "refundRuleKey": null,
    //                 "transferInfo": null,
    //                 "flightTransferVisaTips": null,
    //                 "flightTransferTips": null,
    //                 "trainsitTime": null,
    //                 "dcityCode": 1602,
    //                 "acityCode": 906
    //               }
    //             ],
    //             "queryId": null,
    //             "vendorId": "100#13#8",
    //             "transferVisaTips": null,
    //             "transferTips": null,
    //             "adultPrice": 1021,
    //             "childPrice": 0,
    //             "price": 2042,
    //             "adultFraPrice": 0,
    //             "childFraPrice": 0,
    //             "fraPrice": 0,
    //             "bookInfo": null
    //           },
    //           {
    //             "resId": 0,
    //             "resType": 21,
    //             "resSubType": 0,
    //             "journeyRph": 2,
    //             "seqNum": 2,
    //             "flightKey": "CZ6667",
    //             "transferFlag": 0,
    //             "departTime": "2021-09-19",
    //             "durationTime": "170",
    //             "priceInfoId": "MTMjOA==",
    //             "specVendorId": "",
    //             "inlandTransferInfoList": null,
    //             "priceFlightCabinList": [
    //               {
    //                 "seatTypeCode": 1,
    //                 "seatTypeName": "经济舱",
    //                 "seatAliasName": "",
    //                 "cabinCode": "E",
    //                 "cabinCodeChild": "",
    //                 "baggageInfo": "三亚-南京：免费托运行李20公斤，免费手提行李1件5公斤，备注：尺寸限制：长宽高之和小于等于115厘米;",
    //                 "mealCode": "D",
    //                 "mealName": "正餐",
    //                 "seatDiscount": null,
    //                 "baggageInfoEntity": null,
    //                 "baggageInfoEntityCHD": null,
    //                 "baggageInfoEntityBaby": null,
    //                 "priceDetailInfo": "最少成行人数为：1，最多成行人数为：9",
    //                 "adultPrice": 1061,
    //                 "childPrice": 0,
    //                 "babyPrice": null,
    //                 "price": 2122,
    //                 "adultFraPrice": 0,
    //                 "childFraPrice": 0,
    //                 "babyFraPrice": null,
    //                 "fraPrice": 0,
    //                 "seatStatus": "9"
    //               }
    //             ],
    //             "inlandFlightItemInfoLists": [
    //               {
    //                 "departureDate": "2021-09-19",
    //                 "airlineCompany": "中国南方航空",
    //                 "flightNo": "CZ6667",
    //                 "airplaneType": "32M",
    //                 "airplaneTypeName": "空客A321",
    //                 "departureTime": "17:25",
    //                 "arrivalTime": "20:15",
    //                 "dportName": "凤凰机场",
    //                 "aportName": "禄口机场",
    //                 "duration": "170",
    //                 "stopNum": 0,
    //                 "stopInformation": "",
    //                 "stopPoints": null,
    //                 "codeShare": "",
    //                 "shareAirlineName": null,
    //                 "arrivalDate": "2021-09-19",
    //                 "terminalArrival": "T1",
    //                 "terminalDeparture": "T1",
    //                 "departureCityName": "三亚",
    //                 "destinationCityName": "南京",
    //                 "dportIataCode": "SYX",
    //                 "aportIataCode": "NKG",
    //                 "orgCityIataCode": "SYX",
    //                 "dstCityIataCode": "NKG",
    //                 "airlineIataCode": "CZ",
    //                 "avgDelayTime": "26",
    //                 "planeModel": 2,
    //                 "airComImageUrl": "https://m.tuniucdn.com/fb2/t1/G1/M00/2F/57/Cii9EFbnv8qIS0CeAAAUupbe7w4AACn3AP_6FMAABTS246.png",
    //                 "sairComImageUrl": null,
    //                 "transferFlag": 1,
    //                 "journeyNumber": 0,
    //                 "visaTips": null,
    //                 "onTimeRate": null,
    //                 "saleControl": null,
    //                 "additionals": null,
    //                 "refundRuleKey": null,
    //                 "transferInfo": null,
    //                 "flightTransferVisaTips": null,
    //                 "flightTransferTips": null,
    //                 "trainsitTime": null,
    //                 "dcityCode": 906,
    //                 "acityCode": 1602
    //               }
    //             ],
    //             "queryId": null,
    //             "vendorId": "100#13#8",
    //             "transferVisaTips": null,
    //             "transferTips": null,
    //             "adultPrice": 1061,
    //             "childPrice": 0,
    //             "price": 2122,
    //             "adultFraPrice": 0,
    //             "childFraPrice": 0,
    //             "fraPrice": 0,
    //             "bookInfo": null
    //           }
    //         ],
    //         "adultPrice": 2083,
    //         "childPrice": 0,
    //         "babyPrice": 0,
    //         "price": 4166,
    //         "adultPriceForPc": null,
    //         "childPriceForPc": null,
    //         "adultFraPriceForPc": null,
    //         "childFraPriceForPc": null,
    //         "adultFraPrice": 0,
    //         "childFraPrice": 0,
    //         "inftFraPrice": 0,
    //         "singleAdultFraPrice": 0,
    //         "singleChildFraPrice": 0,
    //         "singleInftFraPrice": 0,
    //         "adultNoTaxFraPrice": 0,
    //         "childNoTaxFraPrice": 0,
    //         "inftNoTaxFraPrice": 0,
    //         "fraPrice": 0,
    //         "queryId": "Y2l0eUtleXM9TktHLVNZWCNTWVgtTktHLGRlcGFydHVyZURhdGU9MjAyMS0wOS0xNSxkZXBhcnR1cmVEYXRlcz0wIzQscGFzc2VuZ2VyUXVhbnRpdHk9MiMwIzAjMCxwaHlzaWNhbENhYmluPW51bGw=",
    //         "needCheckPrice": 1,
    //         "canChoose": 1,
    //         "checkCabinAndPrice": "",
    //         "directionId": 78777
    //       },
    //       "flightSegList": [
    //         {
    //           "orgCityCode": 1602,
    //           "dstCityCode": 906,
    //           "orgCityName": "南京",
    //           "dstCityName": "三亚",
    //           "departureDate": "2021-09-15",
    //           "beginTime": "2021-09-15 00:00:00",
    //           "endTime": "2021-09-16 05:00:00"
    //         },
    //         {
    //           "orgCityCode": 906,
    //           "dstCityCode": 1602,
    //           "orgCityName": "三亚",
    //           "dstCityName": "南京",
    //           "departureDate": "2021-09-19",
    //           "beginTime": "2021-09-19 00:00:00",
    //           "endTime": "2021-09-20 05:00:00"
    //         }
    //       ],
    //       "canReplaceTicket": 1,
    //       "priceDescription": "1、下列机票报价包含燃油附加费和机票税；\\n2、实时计价机票可能会发生价格或位置的变更，请以占位为准，并尽快完成支付。",
    //       "lackResFlag": 0,
    //       "isSingleTeamMixed": 0,
    //       "supportTrafficType": 2,
    //       "useTicketType": 0,
    //       "routeType": null,
    //       "pkgTicketList": [
    //         {
    //           "international": 0,
    //           "flightTicketLists": [
    //             {
    //               "resId": 91464,
    //               "resType": 7,
    //               "resSubType": 0,
    //               "journeyRph": 1,
    //               "seqNum": 1,
    //               "flightKey": null,
    //               "transferFlag": 0,
    //               "departTime": "2021-09-15",
    //               "durationTime": "185",
    //               "priceInfoId": null,
    //               "specVendorId": null,
    //               "inlandTransferInfoList": null,
    //               "priceFlightCabinList": [
    //                 {
    //                   "seatTypeCode": 1,
    //                   "seatTypeName": "经济舱",
    //                   "seatAliasName": null,
    //                   "cabinCode": null,
    //                   "cabinCodeChild": null,
    //                   "baggageInfo": "团队客票G舱\n免费托运行李：10KG\n手提行李：件数1件，重量7KG，尺寸20*30*40",
    //                   "mealCode": null,
    //                   "mealName": null,
    //                   "seatDiscount": "",
    //                   "baggageInfoEntity": null,
    //                   "baggageInfoEntityCHD": null,
    //                   "baggageInfoEntityBaby": null,
    //                   "priceDetailInfo": "2人起订，1人现询\n婴儿现询，团队机票不得退票、不得改期、不得签转\n团队客票G舱\n免费托运行李：10KG\n手提行李：件数1件，重量7KG，尺寸20*30*40\n不含餐食\r\n",
    //                   "adultPrice": 1040,
    //                   "childPrice": 1040,
    //                   "babyPrice": null,
    //                   "price": 2080,
    //                   "adultFraPrice": 0,
    //                   "childFraPrice": 0,
    //                   "babyFraPrice": null,
    //                   "fraPrice": 2080,
    //                   "seatStatus": null
    //                 }
    //               ],
    //               "inlandFlightItemInfoLists": [
    //                 {
    //                   "departureDate": "2021-09-15",
    //                   "airlineCompany": "首都航空",
    //                   "flightNo": "JD5126",
    //                   "airplaneType": null,
    //                   "airplaneTypeName": "中型机",
    //                   "departureTime": "19:55",
    //                   "arrivalTime": "23:00",
    //                   "dportName": "禄口国际机场",
    //                   "aportName": "凤凰国际机场",
    //                   "duration": "185",
    //                   "stopNum": 0,
    //                   "stopInformation": null,
    //                   "stopPoints": null,
    //                   "codeShare": null,
    //                   "shareAirlineName": null,
    //                   "arrivalDate": "2021-09-15",
    //                   "terminalArrival": "T2",
    //                   "terminalDeparture": "T1",
    //                   "departureCityName": "南京",
    //                   "destinationCityName": "三亚",
    //                   "dportIataCode": "NKG",
    //                   "aportIataCode": "SYX",
    //                   "orgCityIataCode": "",
    //                   "dstCityIataCode": "",
    //                   "airlineIataCode": null,
    //                   "avgDelayTime": null,
    //                   "planeModel": 2,
    //                   "airComImageUrl": null,
    //                   "sairComImageUrl": null,
    //                   "transferFlag": 0,
    //                   "journeyNumber": 1,
    //                   "visaTips": null,
    //                   "onTimeRate": "0.0",
    //                   "saleControl": null,
    //                   "additionals": null,
    //                   "refundRuleKey": null,
    //                   "transferInfo": null,
    //                   "flightTransferVisaTips": null,
    //                   "flightTransferTips": null,
    //                   "trainsitTime": null,
    //                   "dcityCode": 1602,
    //                   "acityCode": 906
    //                 }
    //               ],
    //               "queryId": null,
    //               "vendorId": "0",
    //               "transferVisaTips": null,
    //               "transferTips": null,
    //               "adultPrice": 1040,
    //               "childPrice": 1040,
    //               "price": 2080,
    //               "adultFraPrice": 0,
    //               "childFraPrice": 0,
    //               "fraPrice": 2080,
    //               "bookInfo": "2人起订，1人现询\n婴儿现询，团队机票不得退票、不得改期、不得签转\n团队客票G舱\n免费托运行李：10KG\n手提行李：件数1件，重量7KG，尺寸20*30*40\n不含餐食"
    //             },
    //             {
    //               "resId": 91464,
    //               "resType": 7,
    //               "resSubType": 0,
    //               "journeyRph": 2,
    //               "seqNum": 2,
    //               "flightKey": null,
    //               "transferFlag": 0,
    //               "departTime": "2021-09-19",
    //               "durationTime": "185",
    //               "priceInfoId": null,
    //               "specVendorId": null,
    //               "inlandTransferInfoList": null,
    //               "priceFlightCabinList": [
    //                 {
    //                   "seatTypeCode": 1,
    //                   "seatTypeName": "经济舱",
    //                   "seatAliasName": null,
    //                   "cabinCode": null,
    //                   "cabinCodeChild": null,
    //                   "baggageInfo": "团队客票G舱\n免费托运行李：10KG\n手提行李：件数1件，重量7KG，尺寸20*30*40",
    //                   "mealCode": null,
    //                   "mealName": null,
    //                   "seatDiscount": "",
    //                   "baggageInfoEntity": null,
    //                   "baggageInfoEntityCHD": null,
    //                   "baggageInfoEntityBaby": null,
    //                   "priceDetailInfo": "2人起订，1人现询\n婴儿现询，团队机票不得退票、不得改期、不得签转\n团队客票G舱\n免费托运行李：10KG\n手提行李：件数1件，重量7KG，尺寸20*30*40\n不含餐食\r\n",
    //                   "adultPrice": 1039,
    //                   "childPrice": 1039,
    //                   "babyPrice": null,
    //                   "price": 2078,
    //                   "adultFraPrice": 0,
    //                   "childFraPrice": 0,
    //                   "babyFraPrice": null,
    //                   "fraPrice": 2078,
    //                   "seatStatus": null
    //                 }
    //               ],
    //               "inlandFlightItemInfoLists": [
    //                 {
    //                   "departureDate": "2021-09-19",
    //                   "airlineCompany": "首都航空",
    //                   "flightNo": "JD5125",
    //                   "airplaneType": null,
    //                   "airplaneTypeName": "中型机",
    //                   "departureTime": "15:40",
    //                   "arrivalTime": "18:45",
    //                   "dportName": "凤凰国际机场",
    //                   "aportName": "禄口国际机场",
    //                   "duration": "185",
    //                   "stopNum": 0,
    //                   "stopInformation": null,
    //                   "stopPoints": null,
    //                   "codeShare": null,
    //                   "shareAirlineName": null,
    //                   "arrivalDate": "2021-09-19",
    //                   "terminalArrival": "T1",
    //                   "terminalDeparture": "T2",
    //                   "departureCityName": "三亚",
    //                   "destinationCityName": "南京",
    //                   "dportIataCode": "SYX",
    //                   "aportIataCode": "NKG",
    //                   "orgCityIataCode": "",
    //                   "dstCityIataCode": "",
    //                   "airlineIataCode": null,
    //                   "avgDelayTime": null,
    //                   "planeModel": 2,
    //                   "airComImageUrl": null,
    //                   "sairComImageUrl": null,
    //                   "transferFlag": 0,
    //                   "journeyNumber": 1,
    //                   "visaTips": null,
    //                   "onTimeRate": "0.0",
    //                   "saleControl": null,
    //                   "additionals": null,
    //                   "refundRuleKey": null,
    //                   "transferInfo": null,
    //                   "flightTransferVisaTips": null,
    //                   "flightTransferTips": null,
    //                   "trainsitTime": null,
    //                   "dcityCode": 906,
    //                   "acityCode": 1602
    //                 }
    //               ],
    //               "queryId": null,
    //               "vendorId": "0",
    //               "transferVisaTips": null,
    //               "transferTips": null,
    //               "adultPrice": 1039,
    //               "childPrice": 1039,
    //               "price": 2078,
    //               "adultFraPrice": 0,
    //               "childFraPrice": 0,
    //               "fraPrice": 2078,
    //               "bookInfo": "2人起订，1人现询\n婴儿现询，团队机票不得退票、不得改期、不得签转\n团队客票G舱\n免费托运行李：10KG\n手提行李：件数1件，重量7KG，尺寸20*30*40\n不含餐食"
    //             }
    //           ],
    //           "adultPrice": 2079,
    //           "childPrice": 2079,
    //           "babyPrice": 0,
    //           "price": 4158,
    //           "adultPriceForPc": null,
    //           "childPriceForPc": null,
    //           "adultFraPriceForPc": null,
    //           "childFraPriceForPc": null,
    //           "adultFraPrice": 0,
    //           "childFraPrice": 0,
    //           "inftFraPrice": 0,
    //           "singleAdultFraPrice": 0,
    //           "singleChildFraPrice": 0,
    //           "singleInftFraPrice": 0,
    //           "adultNoTaxFraPrice": 0,
    //           "childNoTaxFraPrice": 0,
    //           "inftNoTaxFraPrice": 0,
    //           "fraPrice": 0,
    //           "queryId": null,
    //           "needCheckPrice": 0,
    //           "canChoose": 0,
    //           "checkCabinAndPrice": null,
    //           "directionId": 0
    //         }
    //       ]
    //     },
    //     "tab": "first",
    //     "defaultResIds": [
    //       0,
    //       0
    //     ],
    //     "defaultPrice": [
    //       2042,
    //       2122
    //     ],
    //     "needCheck": 0,
    //     "curFlightNos": [
    //       "CZ6668",
    //       "CZ6667"
    //     ]
    //   }
    // };

    // console.log("rxjs_msg", rxjs_msg);

    // // 打开模态框
    // this.$store.commit("setDialogVisible", true);

    // this.$store.commit("saveRxjsMsg", rxjs_msg);

    // //恢复默认设置H页面
    // this.$store.commit("setTabName", rxjs_msg.parameter.tab);
    // this.getTickets();
    // this.dialogVisible = true;

    // //自动切换自由组合
    // let pkgTicketList =
    //   this.$store.getters.getRxjsMsg.parameter.groupTickets.pkgTicketList;
    // if (!pkgTicketList) {
    //   this.$store.commit("setTabName", "second");
    //   this.$options.methods.loadData.bind(this)();
    // }

    try {
      if (typeof rxjs_subject) {
        rxjs_subject.subscribe((rxjs_msg) => {
          if (rxjs_msg.message == "flightmodal") {
            let obj = new flightTickets();
            obj.clean(this.$store);
            //打开模态框
            this.$store.commit("setDialogVisible", true);
            //初始化数据
            this.$store.commit("saveRxjsMsg", rxjs_msg);
            //推荐组合 清空状态
            this.$store.commit("setTicketIndex", -1);
            //恢复默认设置H页面
            //设置tab（推荐组合还是自由组合）
            this.$store.commit("setTabName", rxjs_msg.parameter.tab);
            //调用loadData去渲染页面:
            //如果是推荐组合(first)就直接关闭loading，直接用数据去渲染页面;
            //自由组合(second)就去接口请求数据再去渲染页面
            this.getTickets();
            //打开模态框 ？？？？？？？？上面已经打开模态框了，为什么还要再去去打开
            // this.dialogVisible = true;
            //自动切换自由组合
            let pkgTicketList =
              this.$store.getters.getRxjsMsg.parameter.groupTickets
                .pkgTicketList;
            //如果输入数据pkgTicketList为null，去请求自由组合接口数据
            if (!pkgTicketList) {
              this.$store.commit("setTabName", "second");
              this.$options.methods.loadData.bind(this)();
            }
          }
        });
      }
    } catch (e) {}
  },
};
</script>
<style scoped lang="scss">
.flight-diaglo {
  display: block;
}
.flight-diaglo-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #777;
  opacity: 0.5;
  filter: alpha(opacity=50);
  z-index: 1111;
}
.flight-diaglo-loading {
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 384px;
  height: 125px;
  line-height: 125px;
  border: 8px solid #777;
  text-align: center;
  z-index: 1112;
  text-align: left;
  .loadingmsg {
    text-align: center;
    img {
      height: 50px;
      position: relative;
      top: 18px;
    }
  }
  .errormsg {
    text-align: center;
    a {
      text-decoration: none;
    }
  }
}
.flight-diaglo-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1000px;
  padding: 0 5px;
  background: #fff;
  z-index: 1112;
  padding-bottom: 30px;
  .fc-header {
    height: 38px;
    line-height: 38px;
    padding-left: 20px;
    border-bottom: 1px solid #eee;
    h2 {
      color: #999;
      font-size: 14px;
      font-weight: bold;
      border-bottom-color: transparent;
      display: inline;
      margin-right: 28px;
      padding-bottom: 7px;
      cursor: pointer;
    }
    .active {
      border-bottom: 2px solid #ff8800;
      color: #666;
      font-size: 18px;
    }
    .close_wrap {
      float: right;
      line-height: 1;
      margin-right: 10px;
      margin-top: 8px;
      cursor: pointer;
      img {
        width: 16px;
      }
    }
  }
}
.fc-content {
  height: 432px;
  overflow: auto;
  padding-bottom: 30px;
}
.fc-content-main {
  padding-top: 15px;
  padding-left: 22px;
  padding-right: 22px;
  .fc-main-left {
    float: left;
    width: 190px;
    margin-right: 10px;
  }
  .fc-main-right {
    float: left;
    width: 736px;
  }
  .width100 {
    width: 100%;
  }
}
</style>
